module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (3).1c7c017f.svg";